// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index_" + {"235":"3575c1e162e68f45bf08","933":"c42113fa2a1210c43f42"}[chunkId] + "_" + chunkId + ".js";
};